<template>
  <div class="edit-block" v-loading="loading">
    <div class="edit-block-form">
      <Form ref="libForm" :model="libForm" :rules="ruleValid" :label-width="136">
        <div class="edit-block_title">基本信息</div>
        <div class="edit-sub-block">
          <!-- 新布局 基本信息左 -->
          <div class="edit-block-side" :class="{'edit-block-side_new': userTypeLeft}">
            <template v-if="pageType === 'yiliaoData' || pageType === 'yiyuanData' || pageType === 'zhongduanData'">
               <FormItem :label-width="90" label="名称" prop="name">
                <Input v-model.trim="libForm.name" placeholder="请输入名称"></Input>
              </FormItem>
              <FormItem :label-width="90" label="曾用名" prop="history_name" :error="libFormErr.history_name">
                <Input v-model.trim="libForm.history_name" placeholder="请输入曾用名" @on-blur="clearError('history_name')"></Input>
              </FormItem>
              <FormItem  :label-width="90" label="来源" prop="source">
                <Select @on-open-change="toggleSelOpen($event, 'elSelSource')" ref="elSelSource" v-model="libForm.source" placeholder="请选择来源">
                  <Option v-for="item in sourceOpts" :value="item.value" :key="item.value" :disabled="item.disabled">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem :label-width="90" label="终端分类" prop="userType" :class="{'form_item_left': userTypeLeft}">
                <RadioGroup v-model="libForm.userType" @on-change="radioChange">
                  <Radio v-for="(item, index) in userTypeOpts" :key="index" :label="item.label">
                    {{item.text}}
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem :label-width="90" label="终端类型" prop="type">
                <Select @on-open-change="toggleSelOpen($event, 'elSelType')" ref="elSelType" v-model="libForm.type" clearable placeholder="请选择终端类型" @on-change="libForm.class= ''">
                  <Option v-for="item in typeOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem :label-width="90" label="终端类别" prop="class" v-if="pageType !== 'companyData'">
                <Select @on-open-change="toggleSelOpen($event, 'elSelClass')" ref="elSelClass" v-model="libForm.class" clearable placeholder="请选择终端类别">
                  <Option v-for="item in classOpts[libForm.type]" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem :label-width="90" label="经营性质" prop="xingzhi">
                <Select @on-open-change="toggleSelOpen($event, 'elSelXingzhi')" ref="elSelXingzhi" v-model="libForm.xingzhi" clearable placeholder="请选择经营性质" @on-change="libForm.suoyouzhi = ''">
                  <Option v-for="item in xingzhiOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem :label-width="90" label="所有制形式" prop="suoyouzhi">
                <Select @on-open-change="toggleSelOpen($event, 'elSelSuo')" ref="elSelSuo" v-model="libForm.suoyouzhi" clearable placeholder="请选择所有制形式">
                  <Option v-for="item in suoyouOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <template v-if="pageType === 'yiliaoData' || pageType === 'yiyuanData'">
                <FormItem :label-width="91" label="药聚汇-等级" prop="yaojuhui">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelYaojuhui')" ref="elSelYaojuhui" v-model="libForm.yaojuhui" clearable placeholder="请选择药聚汇等级">
                    <Option v-for="item in yaojuhuiOpts" :value="item.text" :key="item.text">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="91" label="卫计委-等级" prop="weijiwei" class="">
                  <span class="formitem-info">{{libForm.weijiwei}}</span>
                </FormItem>
                <FormItem :label-width="91" label="微医-等级" prop="weiyi" class="">
                  <span class="formitem-info">{{libForm.weiyi}}</span>
                </FormItem>
              </template>
            </template>
            <template v-if="pageType === 'companyData' || pageType === 'shangyeData' || pageType === 'yaodianData'">
              <FormItem :label-width="90" label="名称" prop="name">
                <Input v-model.trim="libForm.name" placeholder="请输入名称"></Input>
              </FormItem>
              <FormItem :label-width="90" label="曾用名" prop="history_name" :error="libFormErr.history_name">
                <Input v-model.trim="libForm.history_name" placeholder="请输入曾用名" @on-blur="clearError('history_name')"></Input>
              </FormItem>
              <FormItem :label-width="90" label="来源" prop="source" v-if="pageType === 'shangyeData' || pageType === 'yaodianData'">
                <Select @on-open-change="toggleSelOpen($event, 'elSelSource')" ref="elSelSource" v-model="libForm.source" placeholder="请选择来源">
                  <Option v-for="item in sourceOpts" :value="item.value" :key="item.value" :disabled="item.disabled">{{item.text}}</Option>
                </Select>
              </FormItem>
            </template>
            <!-- 新增客户主数据 -->
            <template v-if="pageType === 'kehuData'">
              <FormItem :label-width="90" label="名称" prop="name">
                <Input v-model.trim="libForm.name" placeholder="请输入名称"></Input>
              </FormItem>
              <FormItem :label-width="90" label="曾用名" prop="history_name" :error="libFormErr.history_name">
                <Input v-model.trim="libForm.history_name" placeholder="请输入曾用名" @on-blur="clearError('history_name')"></Input>
              </FormItem>
              <FormItem :label-width="90" label="终端类型" prop="type" v-if="libForm.userType === '5'">
                <Select @on-open-change="toggleSelOpen($event, 'elSelType')" ref="elSelType" v-model="libForm.type" clearable placeholder="请选择终端类型" @on-change="libForm.class= ''">
                  <Option v-for="item in typeOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <template v-if="libForm.userType === '4'">
                <FormItem :label-width="90" label="终端类型" prop="type">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelType')" ref="elSelType" v-model="libForm.type" clearable placeholder="请选择终端类型" @on-change="libForm.class= ''">
                    <Option v-for="item in typeOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="90" label="终端类别" prop="class">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelClass')" ref="elSelClass" v-model="libForm.class" clearable placeholder="请选择终端类别">
                    <Option v-for="item in classOpts[libForm.type]" :value="item.value" :key="item.value">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="90" label="经营性质" prop="xingzhi">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelXingzhi')" ref="elSelXingzhi" v-model="libForm.xingzhi" clearable placeholder="请选择经营性质" @on-change="libForm.suoyouzhi = ''">
                    <Option v-for="item in xingzhiOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="90" label="所有制形式" prop="suoyouzhi">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelSuo')" ref="elSelSuo" v-model="libForm.suoyouzhi" clearable placeholder="请选择所有制形式">
                    <Option v-for="item in suoyouOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="91" label="是否军区" prop="junqu">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelJunQu')" ref="elSelJunQu" v-model="libForm.junqu" clearable placeholder="请选择是否军区">
                    <Option v-for="item in junQuOpts" :value="item.text" :key="item.text">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem :label-width="91" label="药聚汇-等级" prop="yaojuhui">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelYaojuhui')" ref="elSelYaojuhui" v-model="libForm.yaojuhui" clearable placeholder="请选择药聚汇等级">
                    <Option v-for="item in yaojuhuiOpts" :value="item.text" :key="item.text">{{item.text}}</Option>
                  </Select>
                </FormItem>
              </template>
            </template>
          </div>
          <!-- 新布局基本信息右 -->
          <div class="edit-block-side" :class="{'edit-block-side_new': userTypeLeft}">
            <template v-if="pageType === 'yiliaoData' || pageType === 'yiyuanData' || pageType === 'zhongduanData'">
              <template v-if="pageType !== 'yiliaoData' && pageType !== 'yiyuanData'">
                 <FormItem label="药聚汇-等级" prop="yaojuhui">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelYaojuhui')" ref="elSelYaojuhui" v-model="libForm.yaojuhui" clearable placeholder="请选择药聚汇等级">
                    <Option v-for="item in yaojuhuiOpts" :value="item.text" :key="item.text">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem label="卫计委-等级" prop="weijiwei" class="">
                  <span class="formitem-info">{{libForm.weijiwei}}</span>
                </FormItem>
                <FormItem label="微医-等级" prop="weiyi" class="">
                  <span class="formitem-info">{{libForm.weiyi}}</span>
                </FormItem>
              </template>
              <FormItem label="春雨医生-等级" prop="chunyu" class="">
                <span class="formitem-info">{{libForm.chunyu}}</span>
              </FormItem>
              <FormItem label="好大夫-等级" prop="haodaifu" class="">
              <span class="formitem-info">{{libForm.haodaifu}}</span>
              </FormItem>
              <FormItem label="定级" prop="dingji">
                <Select @on-open-change="toggleSelOpen($event, 'elSelDingji')" ref="elSelDingji" v-model="libForm.dingji"  clearable placeholder="请选择定级">
                  <Option v-for="item in dingjiOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem label="定等" prop="dingdeng">
                <Select @on-open-change="toggleSelOpen($event, 'elSelDingdeng')" ref="elSelDingdeng" v-model="libForm.dingdeng" clearable placeholder="请选择定等">
                  <Option v-for="item in dingdengOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem v-for="(Item, index) in baseInfoOpt" :key="index" :label="Item.label">
                <template v-if="Item.type === 'input'">
                  <Input v-model.trim="Item.value" placeholder=""/>
                </template>
                <template v-else-if="Item.type === 'number'">
                  <Input @on-keyup="Item.value = Item.value.replace(/\D/g,'')" v-model="Item.value" placeholder=""/>
                </template>
                  <template v-else-if="Item.type === 'select' ">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelJunqu')" ref="elSelJunqu" v-model="Item.value" clearable :placeholder="'请选择' + Item.label">
                    <Option v-for="(item, index) in yingyeOpts[Item.field]" :value="item.text" :key="index">{{item.text}}</Option>
                  </Select>
                </template>
              </FormItem>
            </template>
            <template v-if="pageType === 'companyData' || pageType === 'shangyeData' || pageType === 'yaodianData'">
              <FormItem label="来源" prop="source" v-if="pageType === 'companyData'">
                <Select @on-open-change="toggleSelOpen($event, 'elSelSource')" ref="elSelSource" v-model="libForm.source" placeholder="请选择来源">
                  <Option v-for="item in sourceOpts" :value="item.value" :key="item.value" :disabled="item.disabled">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem label="终端分类" prop="userType">
                <RadioGroup v-model="libForm.userType" @on-change="radioChange">
                  <Radio v-for="(item, index) in userTypeOpts" :key="index" :label="item.label">
                    {{item.text}}
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="终端类型" prop="type" v-if="pageType === 'shangyeData' || pageType === 'yaodianData'">
                <Select @on-open-change="toggleSelOpen($event, 'elSelType')" ref="elSelType" v-model="libForm.type" clearable placeholder="请选择终端类型" @on-change="libForm.class= ''">
                  <Option v-for="item in typeOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem label="终端类别" prop="class" v-if="pageType === 'shangyeData' || pageType === 'yaodianData'">
                <Select @on-open-change="toggleSelOpen($event, 'elSelClass')" ref="elSelClass" v-model="libForm.class" clearable placeholder="请选择终端类别">
                  <Option v-for="item in classOpts[libForm.type]" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
            </template>
            <!-- 新增客户主数据 -->
            <template v-if="pageType === 'kehuData'">
              <FormItem label="来源" prop="source">
                <Select @on-open-change="toggleSelOpen($event, 'elSelSource')" ref="elSelSource" v-model="libForm.source" placeholder="请选择来源">
                  <Option v-for="item in sourceOpts" :value="item.value" :key="item.value" :disabled="item.disabled">{{item.text}}</Option>
                </Select>
              </FormItem>
              <FormItem label="终端分类" prop="userType" :class="{'form_item_left': userTypeLeft}">
                <RadioGroup v-model="libForm.userType" @on-change="radioChange">
                  <Radio v-for="(item, index) in userTypeOpts" :key="index" :label="item.label">
                    {{item.text}}
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="终端类别" prop="class" v-if="libForm.userType === '5'">
                <Select @on-open-change="toggleSelOpen($event, 'elSelClass')" ref="elSelClass" v-model="libForm.class" clearable placeholder="请选择终端类别">
                  <Option v-for="item in classOpts[libForm.type]" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
              <template v-if="libForm.userType === '4'">
                <FormItem label="微医-等级" prop="weiyi" class="">
                  <span class="formitem-info">{{libForm.weiyi}}</span>
                </FormItem>
                <FormItem label="春雨医生-等级" prop="chunyu" class="">
                  <span class="formitem-info">{{libForm.chunyu}}</span>
                </FormItem>
                <FormItem label="好大夫-等级" prop="haodaifu" class="">
                <span class="formitem-info">{{libForm.haodaifu}}</span>
                </FormItem>
                <FormItem label="定级" prop="dingji">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelDingji')" ref="elSelDingji" v-model="libForm.dingji"  clearable placeholder="请选择定级">
                    <Option v-for="item in dingjiOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem label="定等" prop="dingdeng">
                  <Select @on-open-change="toggleSelOpen($event, 'elSelDingdeng')" ref="elSelDingdeng" v-model="libForm.dingdeng" clearable placeholder="请选择定等">
                    <Option v-for="item in dingdengOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
                  </Select>
                </FormItem>
                <FormItem  :label-width="136" label="卫计委-等级" prop="weijiwei" class="">
                  <span class="formitem-info">{{libForm.weijiwei}}</span>
                </FormItem>
              </template>
            </template>
          </div>
        </div>
        <div class="edit-block_title">营业信息</div>
        <div class="edit-sub-block">
          <div class="edit-block-side" :class="{'edit-block-side_new': userTypeLeft}">
            <FormItem :label-width="90" v-for="(Item, index) in yingyeInfo1" :key="index" :label="Item.label">
              <template v-if="Item.type === 'input'">
                <Input v-model.trim="Item.value" :placeholder="'请输入' + Item.label"/>
              </template>
              <template v-else-if="Item.type === 'number'">
                <Input @on-keyup="Item.value = Item.value.replace(/\D/g,'')" v-model="Item.value" :placeholder="'请输入' + Item.label"/>
              </template>
              <template v-else-if="Item.type === 'date'">
                <DatePicker v-model="Item.value" format="yyyy-MM-dd" type="date" :placeholder="'请输入' + Item.label" :clearable="false" :clearError="false" :editable="false"></DatePicker>
              </template>
              <template v-else-if="Item.type === 'daterange'">
                <DatePicker v-model="Item.child[0].value" format="yyyy-MM-dd" type="date" placeholder="" :clearable="false" :clearError="false" :editable="false" style="width:140px;"></DatePicker>
                <span class="date-between-label">至</span>
                <DatePicker v-model="Item.child[1].value" format="yyyy-MM-dd" type="date" placeholder="" :clearable="false" :clearError="false" :editable="false" style="width:140px;"></DatePicker>
              </template>
              <template v-else-if="Item.type === 'textarea'">
                <Input v-model.trim="Item.value" :placeholder="'请输入' + Item.label" type="textarea"/>
              </template>
              <template v-else-if="Item.type === 'radio'">
                <RadioGroup v-model="Item.value">
                  <Radio v-for="(item, index) in yingyeOpts[Item.field]" :key="index" :label="item.label">
                    {{item.text}}
                  </Radio>
                </RadioGroup>
              </template>
            </FormItem>
          </div>
          <div class="edit-block-side" :class="{'edit-block-side_new': userTypeLeft}">
           <FormItem v-for="(Item, index) in yingyeInfo2" :key="index" :label="Item.label">
              <template v-if="Item.type === 'input'">
                <Input v-model.trim="Item.value" :placeholder="'请输入' + Item.label"/>
              </template>
              <template v-else-if="Item.type === 'number'">
                <Input @on-keyup="Item.value = Item.value.replace(/\D/g,'')" v-model="Item.value" :placeholder="'请输入' + Item.label"/>
              </template>
              <template v-else-if="Item.type === 'date'">
                <DatePicker v-model="Item.value" format="yyyy-MM-dd" type="date" :placeholder="'请输入' + Item.label" :clearable="false" :clearError="false" :editable="false"></DatePicker>
              </template>
              <template v-else-if="Item.type === 'daterange'">
                <DatePicker
                  v-model="Item.child[0].value"
                  format="yyyy-MM-dd" type="date"
                  placeholder="开始日期"
                  :clearable="false"
                  :clearError="false"
                  :editable="false"
                  style="width:140px;"
                  @on-change="startChange"
                ></DatePicker>
                <span class="date-between-label">至</span>
                <DatePicker
                  v-model="Item.child[1].value"
                  format="yyyy-MM-dd" type="date"
                  placeholder="结束日期"
                  :clearable="false"
                  :clearError="false"
                  :editable="false"
                  style="width:140px;"
                  placement="bottom-end"
                  @on-change="endChange"
                ></DatePicker>
              </template>
              <template v-else-if="Item.type === 'textarea'">
                <Input v-model.trim="Item.value" :placeholder="'请输入' + Item.label" type="textarea"/>
              </template>
              <template v-else-if="Item.type === 'radio'">
                <RadioGroup v-model="Item.value">
                  <Radio v-for="(item, index) in yingyeOpts[Item.field]" :key="index" :label="item.label">
                    {{item.text}}
                  </Radio>
                </RadioGroup>
              </template>
              <template v-else-if="Item.type === 'select'">
                <Select @on-open-change="toggleSelOpen($event, 'elSel')" ref="elSel" v-model="Item.value" placeholder="请选择">
                  <Option v-for="(item, index) in yingyeOpts[Item.field]" :value="item.value" :key="index">{{item.text}}</Option>
                </Select>
              </template>
            </FormItem>
          </div>
        </div>
        <div class="edit-block_title">地址信息</div>
        <div class="edit-sub-block">
          <div class="edit-block-side" :class="{'edit-block-side_new': userTypeLeft}">
            <FormItem :label-width="90" label="省" prop="p_name">
              <Input v-model.trim="libForm.p_name" placeholder="请输入省"></Input>
            </FormItem>
            <FormItem :label-width="90" label="市" prop="city_name">
              <Input v-model.trim="libForm.city_name" placeholder="请输入市"></Input>
            </FormItem>
            <FormItem :label-width="90" label="区、县" prop="ad_name">
              <Input v-model.trim="libForm.ad_name" placeholder="请输入区、县"></Input>
            </FormItem>
          </div>
          <div class="edit-block-side" :class="{'edit-block-side_new': userTypeLeft}">
            <FormItem label="地址" prop="address">
              <Input v-model.trim="libForm.address" placeholder="请输入地址"></Input>
            </FormItem>
            <FormItem label="地理位置-经度" prop="location_jingdu">
              <Input v-model.trim="libForm.location_jingdu" placeholder="请输入地理位置-经度"></Input>
            </FormItem>
            <FormItem label="地理位置-纬度" prop="location_weidu">
              <Input v-model.trim="libForm.location_weidu" placeholder="请输入地理位置-纬度"></Input>
            </FormItem>
          </div>
          <div class="edit-block__map">
            <div class="amap-search">
              <Input class="amap-search__input search-input"
                v-model="addrKey"
                placeholder="请输入地址"
                @on-enter="searchAddr"
                @on-keyup="errorAddr = false">
                <template slot="suffix"><i class="yjh-icon icon-search" @click="searchAddr"></i></template>
              </Input>
              <div class="search-no-result" v-if="errorAddr">
                <i class="yjh-icon icon-error"></i>无法获取位置
              </div>
            </div>
            <div id="amap-container"></div>
          </div>
        </div>
      </Form>
    </div>
    <page-bottom-line text="提交保存" :disabled="btnDisabled" @confirm="submit"></page-bottom-line>
  </div>
</template>

<script>
import mapMixin from '@/views/content/components/mapMixin.js'
import addFormOptsMixin from './addFormOptsMixin'
import { checkNameExist } from '@/api/goodStand'
import { msg } from '@/utils/index'
import pageBottomLine from '@/components/pageCom/pageBottomLine.vue'
export default {
  components: { pageBottomLine },
  mixins: [mapMixin, addFormOptsMixin],
  props: {
    // btnDisabled: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('不能为空'))
      }
      const params = {
        name: value,
        history_name: this.libForm.history_name,
        id: this.isAdd ? '' : this.$route.params.id,
        focus: rule.field
      }
      checkNameExist(params).then(res => {
        if (res.code === 0 && res.result.exists === 0) {
          callback()
        } else {
          callback(new Error(res.result.exists))
        }
      })
      if (this.libForm.history_name && value === this.libForm.history_name) {
        msg.call(this, '名称与曾用名重复')
      }
    }
    return {
      btnDisabled: false,
      loading: false,
      baseInfoOpt: [], // 用来放置不同新增的基本信息
      libForm: {
        name: '', // 名称
        history_name: '', // 曾用名
        alias_name: [{ name: '' }], // 其他名字
        source: '', // 来源
        userType: '', // 用户类型 4：医疗卫生机构 5：药品经营企业 6：药品生产企业 69：服务商
        type: '', // 终端类型
        class: '', // 终端类别
        xingzhi: '', // 经营性质
        suoyouzhi: '', // 所有制形式
        junqu: '', // 是否军区
        yaojuhui: '', // 药聚汇等级
        weijiwei: '', // 卫计委等级
        weiyi: '', // 微医等级
        chunyu: '', // 春雨医生等级
        haodaifu: '', // 好大夫等级
        dingji: '', // 定级
        dingdeng: '', // 定等
        p_name: '', // ---- 地址信息 省
        city_name: '', // 市
        ad_name: '', // 区
        address: '', // 地址
        location_jingdu: '', // 经度
        location_weidu: '' // 维度
      },
      libFormErr: { // LibForm组件的错误格式默认只有一个
        history_name: '',
        alias_name: [{ error: '' }]
      },
      typeOpts: [],
      classOpts: {},
      ruleValid: {
        name: [{
          required: true, validator: validateName, trigger: 'blur'
        }],
        source: [{
          required: true, message: '不能为空', trigger: 'change'
        }],
        p_name: [{
          required: true, message: '不能为空', trigger: 'blur'
        }],
        city_name: [{
          required: true, message: '不能为空', trigger: 'blur'
        }],
        ad_name: [{
          required: true, message: '不能为空', trigger: 'blur'
        }],
        address: [{
          required: true, message: '不能为空', trigger: 'blur'
        }]
      },
      sourceOpts: [
        { text: '卫计委', value: '卫计委' },
        { text: '药监局', value: '药监局' },
        { text: '微医', value: '微医' },
        { text: '春雨医生', value: '春雨医生' },
        { text: '好大夫', value: '好大夫' },
        { text: '国信网', value: '国信网' },
        { text: '启信宝', value: '启信宝' },
        { text: '企查查', value: '企查查' },
        { text: '图吧', value: '图吧' },
        { text: '高德', value: '高德' },
        { text: '大众点评', value: '大众点评' },
        { text: '百度搜索', value: '百度搜索' },
        { text: '云势清洗', value: '云势清洗' },
        { text: '只入别名', value: '只入别名' },
        { text: '99医院库', value: '99医院库' },
        { text: '医院大全', value: '医院大全' },
        { text: '医院官网', value: '医院官网' },
        { text: '天眼查', value: '天眼查' },
        { text: '百度', value: '百度' }
      ],
      xingzhiOpts: [ // 经营性质和所有制形式也是联动的
        { value: '7', text: '公立' }, { value: '8', text: '非公立' }
      ],
      yaojuhuiOpts: [
        { value: '1', text: '三级甲等' }, { value: '2', text: '三级乙等' }, { value: '3', text: '三级丙等' },
        { value: '4', text: '二级甲等' }, { value: '5', text: '二级乙等' }, { value: '6', text: '二级丙等' }, { value: '7', text: '一级甲等' },
        { value: '8', text: '一级乙等' }, { value: '9', text: '一级丙等' }, { value: '10', text: '未定级未定等' }, { value: '11', text: '三级' },
        { value: '12', text: '三级未定等' }, { value: '13', text: '二级' }, { value: '14', text: '二级未定等' }, { value: '15', text: '一级' },
        { value: '16', text: '一级未定等' }, { value: '17', text: '未定级甲等' }, { value: '18', text: '未定级乙等' }, { value: '19', text: '未定级丙等' },
        { value: '20', text: '未定级' }, { value: '22', text: '未定等' }
      ],
      dingjiOpts: [
        { value: '21', text: '一级' }, { value: '22', text: '二级' }, { value: '23', text: '三级' },
        { value: '24', text: '未定级' }
      ],
      dingdengOpts: [
        { value: '25', text: '甲等' }, { value: '26', text: '乙等' }, { value: '27', text: '丙等' },
        { value: '28', text: '未定等' }
      ],
      junQuOpts: [
        { value: '29', text: '是' }, { value: '30', text: '否' }
      ]
    }
  },
  computed: {
    pageType() {
      /**
       * kehuData  客户主数据库
       * companyData 生产企业数据库
       * shangyeData 中国商业数据库
       * yiliaoData 中国医疗机构库
       * yaodianData 中国药店数据库
       * yiyuanData 中国医院数据库
       * zhongduanData 第三终端数据库
       */
      return this.$route.params.type
    },
    userTypeLeft() { // 目前不需要
      // 针对于页面布局调整 终端在左侧添加的判断条件
      // yiliaoData yiyuanData zhongduanData 暂未放入
      // const targetTypes = ['kehuData']
      // return targetTypes.includes(this.pageType)
      return false
    },
    // 当前页面功能是 新增还是 编辑
    isAdd() {
      return this.$route.name === 'addData'
    },
    // 根据经营性质联动所有制形式
    suoyouOpts() {
      if (this.libForm.xingzhi === '7') {
        // 公立
        return [
          { value: '17', text: '国有' },
          { value: '18', text: '集体' },
          { value: '68', text: '未知' },
          { value: '0', text: '为空' }
        ]
      } else if (this.libForm.xingzhi === '8') {
        return [
          { value: '19', text: '联营' },
          { value: '20', text: '私营' },
          { value: '0', text: '为空' }
        ]
      } else {
        return []
      }
    }
  },
  mounted() {
    const _this = this
    document.querySelector('.cont-return').addEventListener('scroll', () => {
      for (const refName in _this.$refs) {
        if (refName === 'elSel' && _this.$refs[refName] !== undefined) {
          _this.$refs[refName].map(item => {
            item.visible && (item.visible = false)
          })
        } else if (refName.includes('elSel') && _this.$refs[refName] !== undefined) {
          if (refName === 'elSelJunqu') {
            _this.$refs[refName][0].visible && (_this.$refs[refName][0].visible = false)
          }
          _this.$refs[refName].visible && (_this.$refs[refName].visible = false)
        }
      }
    })
  },
  methods: {
    // 新增别名
    addOtherName(index) {
      this.libForm.alias_name.push({
        name: ''
      })
      this.libFormErr.alias_name.push({
        error: ''
      })
    },
    // 删除别名
    delOtherName(i) {
      this.libForm.alias_name.splice(i, 1)
      this.libFormErr.alias_name.splice(i, 1)
    },
    // 清除错误提示
    clearError(name, index) {
      if (name === 'history_name' && this.libForm.history_name === '') {
        this.libFormErr.history_name = ''
      }
      if (name === 'history_name') {
        if (this.libForm.history_name.trim() !== '') {
          const params = {
            name: this.libForm.name,
            history_name: this.libForm.history_name,
            id: this.isAdd ? '' : this.$route.params.id,
            focus: name
          }
          checkNameExist(params).then(res => {
            if (res.code === 0 && res.result.exists === 0) {
              this.libFormErr[name] = ''
            } else {
              this.libFormErr[name] = res.result.exists
            }
          })
        }
      }
      // 别名-没用-可删掉
      if (name === 'alias_name') {
        const curAliasName = this.libForm.alias_name[index].name
        if (curAliasName === '' && index === 0 && this.libForm.alias_name.length > 1) {
          this.libFormErr[name][index].error = '不能为空'
          return
        }
        if (curAliasName === '' && index === 0 && this.libForm.alias_name.length === 1) {
          this.libFormErr[name][index].error = ''
        }
        if (curAliasName === '' && index !== 0) {
          this.libFormErr[name][index].error = '不能为空'
          return
        }
        if (curAliasName !== '') {
          checkNameExist({ name: curAliasName, id: this.isAdd ? '' : this.$route.params.id }).then(res => {
            if (res.code === 0 && res.result.exists === 1) {
              this.libFormErr[name][index].error = '名称已存在'
            } else {
              this.libFormErr[name][index].error = ''
            }
          })
        }
        if (this.libForm.name && this.libForm.name === curAliasName) {
          msg.call(this, '别名和名称不能重复')
          return false
        }
        if (this.libForm.history_name && this.libForm.history_name === curAliasName) {
          msg.call(this, '别名和曾用名不能重复')
          return false
        }
        if (index !== '') {
          let Flag = false
          this.libForm.alias_name.forEach((item, Index) => {
            if (Index !== index && item.name === curAliasName) {
              Flag = true
            }
          })
          if (Flag) {
            msg.call(this, '别名重复')
            return false
          }
        }
      }
    },
    changeSunDisabled(type = false) {
      if (type) {
        this.btnDisabled = true
      } else {
        this.btnDisabled = !this.btnDisabled
      }
    },
    // 提交
    submit() {
      this.changeSunDisabled()
      this.$refs.libForm.validate((valid) => {
        if (!valid) {
          this.changeSunDisabled()
          return false
        }
        if (this.libFormErr.history_name) {
          this.changeSunDisabled()
          return false
        }
        if (this.libForm.name.trim() === this.libForm.history_name.trim()) {
          this.changeSunDisabled()
          return
        }
        this.libForm.alias_name.forEach((obj, index) => {
          if (obj.name === '' && index === 0 && this.libForm.alias_name.length > 1) {
            this.changeSunDisabled()
            this.libFormErr.alias_name[index].error = '不能为空'
          } else if (obj.name === '' && index !== 0) {
            this.changeSunDisabled()
            this.libFormErr.alias_name[index].error = '不能为空'
          } else {
            this.libFormErr.alias_name[index].error = ''
          }
        })
        const Flag = this.libFormErr.alias_name.some(obj => {
          this.changeSunDisabled()
          return obj.error
        })
        if (Flag) {
          this.changeSunDisabled()
          return false
        }
        if (!this.checkAliasName()) {
          this.changeSunDisabled()
          return false
        }
        this.getParams()
      })
    },
    // 检验别名
    checkAliasName() {
      const emptyArr = []
      for (var i = 0; i < this.libForm.alias_name.length; i++) {
        const curAliasName = this.libForm.alias_name[i].name
        if (curAliasName && this.libForm.name && curAliasName === this.libForm.name) {
          msg.call(this, '别名与名称重复')
          return false
        }
        if (curAliasName && this.libForm.history_name && curAliasName === this.libForm.history_name) {
          msg.call(this, '别名与曾名称重复')
          return false
        }
        if (emptyArr.includes(curAliasName)) {
          msg.call(this, '别名重复')
          return false
        }
        if (curAliasName !== '') {
          emptyArr.push(curAliasName)
        }
      }
      return true
    },
    startChange() {
      this.yingyeInfo2.forEach(item => {
        if (item.child && item.child.length) {
          if (item.child[0] && item.child[1] && (item.child[0].value.getTime() > item.child[1].value.getTime())) {
            msg.call(this, '开始时间不能大于结束时间')
            item.child[0].value = ''
          }
        }
      })
    },
    endChange() {
      this.yingyeInfo2.forEach(item => {
        if (item.child && item.child.length) {
          if (item.child[0] && item.child[1] && (item.child[0].value.getTime() > item.child[1].value.getTime())) {
            msg.call(this, '开始时间不能大于结束时间')
            item.child[1].value = ''
          }
        }
      })
    },
    radioChange() {
      this.libForm.type = ''
      this.libForm.xingzhi = ''
      this.libForm.suoyouzhi = ''
      this.libForm.junqu = ''
      this.libForm.yaojuhui = ''
      this.libForm.dingji = ''
      this.libForm.dingdeng = ''
    },
    toggleSelOpen(flag, refName) {
      if (flag && this.$refs[refName] !== undefined) {
        this.$nextTick(() => {
          if (this.$refs[refName].$el !== undefined) {
            this.$refs[refName].$el.querySelector('.ivu-select-dropdown').scrollTop = 0
          } else {
            this.$refs[refName].map(item => {
              item.$el.querySelector('.ivu-select-dropdown').scrollTop = 0
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .eidt-block {
    position: relative;
  }
  .edit-block-side {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 10px;
    &:nth-child(odd) { width: 40%; }
    &:nth-child(even) { width: 60%; }
    .ivu-input-wrapper,
    .ivu-select,
    .ivu-date-picker {
      width: 220px;
    }
    .ivu-form-item {
      .ivu-radio-wrapper {
        &:last-child {
          margin-right: 0px;
        }
      }
    }
    .form_item_left { // 调整布局终端分类样式
      /deep/ .ivu-radio-group {
        .ivu-radio {
          margin-right: 0px;
        }
      }
    }
    .formitem-info {
      min-height: 20px;
      height: 20px;
    }
    .ivu-form-item-label {
      line-height: 20px;
    }
  }
  .edit-block-side_new { // 左右模块的宽度
    &:nth-child(odd) { width: 50%; }
    &:nth-child(even) { width: 50%; }
  }
  .date-between-label {
    font-size: 12px;
    line-height: 32px;
    margin: 0 10px;
  }
  .edit-block_title {
    font-size: 14px;
    font-weight: bold;
    padding: 30px 0;
    border-top: 1px solid #ECF0F7;
    &:first-child {
      border: 0;
      padding-top: 0;
    }
  }
  .edit-block__map {
    margin-top: 30px;
  }
  .edit-block__ope {
    display: inline-block;
    margin-left: 10px;
    .yjh-icon {
      margin-right: 0;
    }
    .yjh-icon + .yjh-icon {
      margin-left: 12px;
    }
  }
  .search-no-result {
    display: inline-block;
    line-height: 32px;
    margin-left: 10px;
  }
  .amap-search {
    height: 32px;
    margin-bottom: 10px;
    text-align: left;
    .amap-search__input {
      width: 220px;
      height: 32px;
    }
  }
  #amap-container {
    width: 100%;
    height: 320px;
  }
  .formitem-info {
    font-size: 12px;
  }
  .page-fixed-line {
    z-index: 200;
  }
  /deep/ .ivu-form-item-content {
    white-space: nowrap;
  }
  /deep/ .ivu-icon-ios-loading:before {
    content: ''
  }
</style>
<style lang="scss">
  .edit-block {
    .ivu-form-item-error-tip {
      margin-left: 10px;
      .edit-block__othername &{
        margin-left: 0px;
      }
    }
  }
</style>
